import Vue from 'vue'
import XEClipboard from 'xe-clipboard'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import './pro/vxe-table-pro.es6.min'
import './pro/vxe-table-pro.min.css'
import './defaults'
import './formats'

import VXETablePluginMenus from 'vxe-table-plugin-menus'
import VXETablePluginShortcutKey from 'vxe-table-plugin-shortcut-key'

import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'

Vue.use(VXETable)
Vue.prototype.$XModal = VXETable.modal

// 导出
VXETable.use(VXETablePluginExportXLSX)

// 给右键菜单的复制按钮设置为剪贴板操作函数
VXETable.use(VXETablePluginMenus, {
  copy: XEClipboard.copy
})
// 快捷键设置
VXETable.use(VXETablePluginShortcutKey, {
  // 快捷键监听
  listener: {
    ArrowDown(params) {
      if (!params.$table.activeCellArea) {
        const activeRecord = params.$table.getActiveRecord()
        const column = activeRecord.column
        let row = activeRecord.row
        // const keyboardConfig = params.$table.keyboardConfig
        // if (!keyboardConfig.isArrow) {
        //   const index = params.$table.getRowIndex(row)
        //   if (index + 1 < params.$table.data.length) {
        //     row = params.$table.data[index + 1]
        //   }
        // }
        params.$table.clearActived()
        params.$table.setCellAreas([
          {
            type: 'main',
            startColumn: column,
            endColumn: column,
            startRow: row,
            endRow: row
          }
        ])
      }
    },
    ArrowUp(params) {
      if (!params.$table.activeCellArea) {
        const activeRecord = params.$table.getActiveRecord()
        const column = activeRecord.column
        let row = activeRecord.row
        // const keyboardConfig = params.$table.keyboardConfig
        // if (!keyboardConfig.isArrow) {
        //   const index = params.$table.getRowIndex(row)
        //   if (index > 0) {
        //     row = params.$table.data[index - 1]
        //   }
        // }
        params.$table.clearActived()
        params.$table.setCellAreas([
          {
            type: 'main',
            startColumn: column,
            endColumn: column,
            startRow: row,
            endRow: row
          }
        ])
      }
    }
  },
  // 功能键设置
  setting: {
    'pager.prevPage': 'ArrowLeft',
    'pager.nextPage': 'ArrowRight', // 单个按键
    'pager.prevJump': 'Shift + W',
    'pager.nextJump': 'Shift + S'
  }
})
